import { useCallback, useRef, useState } from "react";

function playSuccessTone() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;

  if (!AudioContext) {
    return;
  }

  const audioContext = new AudioContext();
  const oscillator = audioContext.createOscillator();
  const gain = audioContext.createGain();
  const now = audioContext.currentTime;

  oscillator.type = "sine";
  oscillator.frequency.setValueAtTime(880, now);
  oscillator.frequency.setValueAtTime(1175, now + 0.08);
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.16, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);

  oscillator.connect(gain);
  gain.connect(audioContext.destination);
  oscillator.start(now);
  oscillator.stop(now + 0.24);

  oscillator.onended = () => {
    audioContext.close().catch(() => {});
  };
}

export function useSuccessFeedback() {
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef(null);

  const triggerSuccessFeedback = useCallback(() => {
    playSuccessTone();
    setVisible(true);

    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      setVisible(false);
      timeoutRef.current = null;
    }, 2000);
  }, []);

  return { successVisible: visible, triggerSuccessFeedback };
}

export function SuccessToast({ visible }) {
  if (!visible) {
    return null;
  }

  return (
    <div className="success-toast" role="status" aria-live="polite">
      Erledigt
    </div>
  );
}
